import request from '@/plugin/axios'

export function page(query) {
return request({
url: '/api/admin/materialPreview/page',
method: 'get',
params: query
})
}

export function addObj(obj) {
return request({
url: '/api/admin/materialPreview/save',
method: 'post',
data: obj
})
}

export function getObj(id) {
return request({
url: '/api/admin/materialPreview/' + id,
method: 'get'
})
}

export function previewList(id) {
    return request({
        url: '/api/admin/materialPreview/preview/' + id,
        method: 'get'
    })
}

export function delObj(id) {
return request({
url: '/api/admin/materialPreview/' + id,
method: 'delete'
})
}

export function putObj(id, obj) {
return request({
url: '/api/admin/materialPreview/' + id,
method: 'put',
data: obj
})
}
